import AppBar from "../../components/AppBar";
import ChatBotBar from "../../components/ChatBotBar";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../services/api_services/ApiServices";
import botImg from "../../assets/png/bot.png";
import { useEffect, useState, useRef } from "react";
import CircularLoader from "../../components/CicularLoader";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import deleteIcon from "../../assets/svg/chat-bot/delete-icon.svg";
import maiIcon from "../../assets/png/bot.png";
import editIcon from "../../assets/svg/edit.svg";
import CustomButton from "../../components/Button";
import Button from "../../components/Button";
import ConfirmDialog from "../../components/ConfirmDialog";
import "react-toastify/dist/ReactToastify.css";

const ChatBotEdit = () => {
  const { state } = useLocation();
  const name = state?.name;
  const application_id = state?.application_id;
  const [excelBase64, setExcelBase64] = useState("");
  const navigate = useNavigate();

  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [botEditList, SetBotsEdit] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [botHeader, SetBotHead] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState({
    id: null,
  });
  const hasFetchedRef = useRef(false);

  const handleDeleteClick = (item) => {
    setDeleteId({
      id: item.id,
    });
    setOpenDialog(true);
  };
  const handleAddQuestion = () => {
    const hasIncompleteRow = botEditList.some(
      (item) =>
        item.id === null && (!item.question?.trim() || !item.answer?.trim()),
    );

    if (hasIncompleteRow) {
      toast.error("Please complete the current Question & Answer first");
      return;
    }

    const newItem = {
      id: null,
      question: "",
      answer: "",
    };

    SetBotsEdit((prev) => [newItem, ...prev]);
    setEditingIndex(0);
  };

  const queAnsInsert = async (question, answer) => {
    setLoading(true);
    try {
      const payload = {
        items: [
          {
            id: null,
            question: question,
            answer: answer,
            app_id: botHeader.application_id,
            bot_name: botHeader.bot_name,
            application_name: botHeader.application_name,
          },
        ],
      };

      const response = await apiRequest({
        url: "bot_update",
        method: "PUT",
        data: payload,
      });

      if (response?.success) {
        toast.success(response?.message || "Inserted successfully");
      } else {
        toast.error(response?.message || "Insert failed");
      }
    } catch (e) {
      toast.error("Insert error");
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    await botQuestionsDelete();
    setOpenDialog(false);
  };
  useEffect(() => {
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    if (name && application_id) {
      fetchBotDetails();
    }
  }, [name, application_id]);

  const fetchBotDetails = async () => {
    try {
      const response = await apiRequest({
        url: "bot_view",
        method: "get",
        params: {
          bot_name: name,
          app_id: application_id,
        },
      });
      if (response.statusCode == 400) {
      } else {
        SetBotHead(response ?? {});
        const apiData = response?.data;

        SetBotsEdit(apiData ?? []);
      }
    } catch (e) {
      toast.error("Update error", e);
    }
  };

  const updateBotEditItem = (index, field, value) => {
    SetBotsEdit((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    );
  };

  const queAnsUpdate = async (id, question, answer) => {
    setLoading(true);
    try {
      const payload = {
        items: [
          {
            id: id,
            question: question,
            answer: answer,
            app_id: botHeader.application_id,
          },
        ],
      };

      const response = await apiRequest({
        url: "bot_update",
        method: "PUT",
        data: payload,
      });
      if (response.statusCode == 400) {
        setLoading(false);
      } else {
        if (response?.success) {
          toast.success(response?.message || "Questions updated successfully");
          setEditingIndex(null);
        } else {
          toast.error(response?.message || "Update failed");
        }
      }
    } catch (e) {
      toast.error("Update error", e);
      setLoading(false);
      fetchBotDetails();
    } finally {
      setLoading(false);
    }
  };
  const handleQuestionChange = (index, value) => {
    const updated = [...botEditList];
    updated[index].question = value;
    SetBotsEdit(updated);
  };

  const handleAnswerChange = (index, value) => {
    const updated = [...botEditList];
    updated[index].answer = value;
    SetBotsEdit(updated);
  };

  const botQuestionsDelete = async () => {
    try {
      const response = await apiRequest({
        method: "delete",
        url: "QA_delete",
        data: {
          pre_id: String(deleteId.id),
        },
      });

      if (response.statusCode == 400) {
      } else {
        if (response?.success) {
          fetchBotDetails();
          navigate("/admin_setting", { state: { selectedTab: "Chatbots" } });
          toast.success(response?.message);
        } else {
          toast.error(response?.message || "Failed to fetch applications");
        }
      }
    } catch (error) {
      toast.error("Application list error:", error);
    }
  };

  return initialLoading ? (
    <div className="flex items-center justify-center h-screen gap-2 bg-gray-200 ">
      <img src={maiIcon} alt="icon" className="h-[30px] w-[30px]  "></img>
      <span className="font-medium text-blue-800"> mai loading...</span>
    </div>
  ) : (
    <div className="min-h-screen flex flex-col bg-[#F8F9FB]">
      <AppBar title="Settings" onClick={() => navigate("/")} />

      <ChatBotBar
        title={botHeader.bot_name}
        onClickPop={() =>
          navigate("/admin_setting", { state: { selectedTab: "Chatbots" } })
        }
      />

      <ConfirmDialog
        open={openDialog}
        title="Delete Bot"
        message={`Are you sure you want to delete ?`}
        onConfirm={confirmDelete}
        onCancel={() => setOpenDialog(false)}
      />

      <div className="flex-1 px-6 py-6 space-y-6">
        <div className="bg-white rounded-xl p-3 flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-[#E2EFFF] flex items-center justify-center">
            <img src={botImg} alt="bot_Img" className="w-8 h-8" />
          </div>

          <div className="items-center justify-center pt-3">
            <p className="text-2xs text-base leading-none items-center font-omny font-medium">
              {botHeader.bot_name}
            </p>
            <p className="text-2xs text-[#2C8C53] font-omny font-semibold leading-none items-center">
              {botHeader.application_name}
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6  font-omny font-semibold ">
          <div className="flex items-center justify-between gap-4 flex-wrap pb-3">
            <h2 className="text-xl font-bold">Question & Answers</h2>

            <div className="flex gap-3 items-center">
              <Button
                label="+ Add"
                onClick={handleAddQuestion}
                color="bg-gray-100 text-black"
              />

              {excelBase64 && <Button label="Remove Excel" variant="remove" />}
            </div>
          </div>

          <div className="overflow-hidden border rounded-lg">
            <table className="w-full text-sm border-collapse">
              <thead className="bg-[#F5F5F5] text-left">
                <tr>
                  <th className="px-4 py-2 w-16 border-r border-[#D4D4D4] font-omny font-semibold">
                    S.No
                  </th>
                  <th className="px-4 py-2 border-r border-[#D4D4D4] font-omny font-semibold">
                    Question
                  </th>
                  <th className="px-4 py-2 font-omny font-semibold">Answer</th>
                </tr>
              </thead>

              <tbody>
                {botEditList.map((item, index) => (
                  <tr
                    key={item.id}
                    className="border-t font-omny font-medium"
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td className="px-4 py-2 border-r border-[#D4D4D4] text-center">
                      {index + 1}
                    </td>
                    <td className="px-1 py-2 border-r border-[#D4D4D4]">
                      {editingIndex === index ? (
                        <textarea
                          value={item.question}
                          onChange={(e) =>
                            updateBotEditItem(index, "question", e.target.value)
                          }
                          rows={1}
                          className="w-full px-4 py-2 bg-transparent resize-none outline-none focus:ring-0 font-omny font-medium"
                        />
                      ) : (
                        <div className="px-4 py-2 break-words whitespace-pre-wrap">
                          {item.question}
                        </div>
                      )}
                    </td>

                    <td className="px-6 py-2">
                      {editingIndex === index ? (
                        <div className="flex">
                          <textarea
                            value={item.answer}
                            onChange={(e) =>
                              updateBotEditItem(index, "answer", e.target.value)
                            }
                            rows={1}
                            className="w-full px-4 py-3 bg-transparent resize-none outline-none focus:ring-0 font-omny font-medium"
                          />
                          {hoveredRow === index && (
                            <div className="flex gap-3 justify-center items-center">
                              <CustomButton
                                label="Cancel"
                                type="button"
                                variant="secondary"
                                className="h-[35px] w-[80px] rounded-lg"
                                onClick={() => {
                                  fetchBotDetails();
                                  setEditingIndex(null);
                                }}
                              />
                              <CustomButton
                                label={
                                  loading ? (
                                    <CircularLoader
                                      size={16}
                                      color="border-white"
                                    />
                                  ) : item.id ? (
                                    "Update"
                                  ) : (
                                    "Insert"
                                  )
                                }
                                type="button"
                                variant="update"
                                className="h-[35px] w-[80px] rounded-lg text-white"
                                onClick={() => {
                                  const trimmedQuestion = item.question?.trim();
                                  const trimmedAnswer = item.answer?.trim();

                                  if (!trimmedQuestion || !trimmedAnswer) {
                                    toast.error(
                                      "Question and Answer cannot be empty",
                                    );
                                    return;
                                  }

                                  if (item.id) {
                                    queAnsUpdate(
                                      item.id,
                                      trimmedQuestion,
                                      trimmedAnswer,
                                    );
                                  } else {
                                    queAnsInsert(
                                      trimmedQuestion,
                                      trimmedAnswer,
                                    );
                                  }

                                  setEditingIndex(null);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="justify-between items-center flex">
                          <div className="px-4 py-2 break-words whitespace-pre-wrap">
                            {item.answer}
                          </div>
                          {hoveredRow === index ? (
                            <div className="flex gap-3">
                              <div
                                className="w-8 h-8 flex items-center justify-center cursor-pointer rounded-full hover:bg-green-100 transition-colors"
                                onClick={() => {
                                  setEditingIndex(index);
                                }}
                              >
                                <img
                                  src={editIcon}
                                  alt="edit"
                                  className="w-4 h-4"
                                ></img>
                              </div>

                              <div
                                className="w-8 h-8 flex items-center justify-center cursor-pointer rounded-full hover:bg-red-100 transition-colors"
                                onClick={() => handleDeleteClick(item)}
                              >
                                <img
                                  src={deleteIcon}
                                  alt="delete"
                                  className="w-5 h-5"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBotEdit;
